<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th style="width: 10%;">{{ t('Shop') }}</th>
                    <th style="width: 20%;">{{ t('Seller') }}</th>
                    <th style="width: 30%;">{{ t('Name') }}</th>
                    <th>{{ t('Price') }}</th>
                    <th>{{ t('Previous price') }}</th>
                    <th>{{ t('Price percent diff') }}</th>
                    <th>{{ t('Date start of drop price') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items">
                    <td>{{ item.shop_name }}</td>
                    <td>
                        <span v-show="item.seller_name">{{ item.seller_name }}</span>
                    </td>
                    <td>
                        <a :href="item.link" target="_blank" rel="noreferrer">{{ item.name }}</a>
                    </td>
                    <td>{{item.price}}</td>
                    <td>{{item.prev_price}}</td>
                    <td>{{item.price_percent_diff}}%</td>
                    <td>{{item.price_down_begin_at}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    const moment = require('moment');

    export default
    {
        components: {},
        props: {
            url: {
                type: String
            },
            items: {
                type: Array,
                required: false
            }
        },
        data()
        {
            return {
            };
        },
        mounted()
        {
        },
    }
</script>


// WEBPACK FOOTER //
// WhoFirstDropPrice.vue?f8558610